import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function JanmashtamiCelebrations2025() {
    const janmashtamiImages = [
        "1000299385.jpg",
        "1000299388.jpg",
        "1000299462.jpg",
        "1000299465.jpg",
        "1000299504.jpg",
        "1000299559.jpg",
        "1000299840.jpg",
        "1000299841.jpg",
        "1000299939.jpg",
        "1000300068.jpg",
        "1000300083.jpg",
        "1000300086.jpg",
        "1000300095.jpg",
        "1000300107.jpg",
        "1000300416.jpg",
        "1000301658.jpg",
        "1000301677.jpg",
        "1000301680.jpg",
        "1000301863.jpg",
    ];

    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        Janmashtami celebrations   18-19, August 2025

                                    </h2>

                                    <div className="css-script-ads"></div>
                                    <div className="spotlight-group">
                                        <div className="row">

                                            {janmashtamiImages.map((file, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/janmashtami-celebrations-2025/${file}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/janmashtami-celebrations-2025/${file}`}
                                                            loading="lazy"
                                                            alt={`Janmashtami Celebrations 2025 - Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default JanmashtamiCelebrations2025;
